// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sBrD","importantInfo":"styles_importantInfo__2pJuA"};